import { Pipe, PipeTransform } from '@angular/core';
import { GalleryTheme } from '@nusign/picflow-backend-types';
import { objectsMatch } from '../../lib/objects-match';

@Pipe({
  name: 'isActiveTheme',
})
export class IsActiveThemePipe implements PipeTransform {
  transform(theme: GalleryTheme, galleryTheme: GalleryTheme): boolean {
    return objectsMatch(theme, galleryTheme);
  }
}
